// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2W2NG","title":"ClientInsurance_title__2yVBt","itemText":"ClientInsurance_itemText__3KGf0"};